var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPakett01BSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "80px",
    viewBox: "0 0 140 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pakett_01b_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pakett_01b",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 4,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 131,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 113,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 95,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 77,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 58,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 40,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 22,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy",
    transform: "translate(4.000000, 30.000000)",
    stroke: "#E7A300",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60.1950031,0 C62.3264999,1.38480724e-15 64.0835706,1.67141215 64.1900125,3.80024953 L64.8099875,16.1997505 C64.9164294,18.3285878 66.6735001,20 68.8049969,20 L128,20 L128,20",
    id: "Path-14"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 128,
    cy: 20,
    r: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakett01BSvg);
export default __webpack_public_path__ + "static/media/Pakett_01b_SVG.5a8b3ec18e49ec0cce6437db967a44a0.svg";
export { ForwardRef as ReactComponent };